import { useEffect, useState } from "react";
import { sfx } from "../helpers/sfx";
import { pushToast } from "./Toaster";
import { fireFireworks } from "../helpers/confettiFx";

const SEQ = [
  "ArrowUp", "ArrowUp",
  "ArrowDown", "ArrowDown",
  "ArrowLeft", "ArrowRight",
  "ArrowLeft", "ArrowRight",
  "b", "a",
];

export function useKonami() {
  const [active, setActive] = useState<boolean>(() => {
    try { return localStorage.getItem("ss-disco") === "1"; } catch { return false; }
  });

  useEffect(() => {
    let buf: string[] = [];
    const onKey = (e: KeyboardEvent) => {
      const tgt = e.target as HTMLElement | null;
      if (tgt && (tgt.tagName === "INPUT" || tgt.tagName === "TEXTAREA" || tgt.isContentEditable)) return;
      buf.push(e.key);
      if (buf.length > SEQ.length) buf = buf.slice(-SEQ.length);
      const ok = buf.length === SEQ.length && buf.every((k, i) => k.toLowerCase() === SEQ[i].toLowerCase());
      if (ok) {
        setActive((a) => {
          const next = !a;
          try { localStorage.setItem("ss-disco", next ? "1" : "0"); } catch {}
          if (next) {
            sfx.konami();
            fireFireworks(2500);
            pushToast({ emoji: "🕺", title: "DISCO MODE: ON", body: "Powtórz kombinację, by wyłączyć", variant: "success" });
          } else {
            pushToast({ emoji: "✨", title: "Disco mode: OFF", variant: "info" });
          }
          return next;
        });
        buf = [];
      }
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, []);

  useEffect(() => {
    document.body.classList.toggle("disco-mode", active);
  }, [active]);

  return active;
}
